export const generateShareName = (label, existingGrants) => {
    const prefixMap = {
      'Founder': 'FO',
      'Seed': 'SE',
      'Series A': 'A',
      'Series B': 'B',
      'Series C': 'C',
      'Series D': 'D',
    };
  
    const prefix = prefixMap[label] || label.slice(0, 2).toUpperCase();
    const filtered = existingGrants.filter(g => g.share_name?.startsWith(prefix));
    const nextId = String(filtered.length + 1).padStart(2, '0');
  
    return `${prefix}-${nextId}`;
  };
  